import { useState, useEffect } from "react";
import axios from "axios";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from '../../../Axios'


export default function StaffList() {
  const [staff, setStaff] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  // Fetch staff data from API
  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_BASE_URL}/api/v1/staff`);
        setStaff(response.data.staff);
        // console.log("Dharma",response);
      } catch (error) {
        console.error("Error fetching staff:", error);
        toast.error("Failed to fetch staff data.");
      }
    };

    fetchStaff();
  }, []);

  // Handle the "View" button click
  const handleViewClick = (staffMember) => {
    setSelectedStaff(staffMember);
    setShowModal(true);
    setIsEditing(false);
  };

  // Handle delete staff by ID
  const handleDelete = async (_id) => {
    try {
      await api.delete(`/api/v1/staff/${_id}`);
      setStaff(staff.filter((member) => member._id !== _id));
      toast.success("Staff deleted successfully!");
    } catch (error) {
      console.error("Error deleting staff:", error);
      toast.error("Failed to delete staff. Please try again.");
    }
  };

  // Handle "Edit" button click
  const handleEdit = (staffMember) => {
    setSelectedStaff({ ...staffMember });
    setIsEditing(true);
    setShowModal(true);
  };

  // Handle form submission for updating staff
  const handleUpdateStaff = async () => {
    if (!selectedStaff.name || selectedStaff.name.trim() === "") {
      toast.error("Name is required to update staff!");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("name", selectedStaff.name);
      formData.append("Qualification", selectedStaff.Qualification);
      formData.append("department", selectedStaff.department);
      formData.append("Specialization", selectedStaff.Specialization);
      formData.append("Experience", selectedStaff.Experience);

      if (selectedStaff.profilePhotoFile) {
        formData.append("profilePhoto", selectedStaff.profilePhotoFile);
      }

      const response = await api.put(
        `/api/v1/staff/${selectedStaff._id}`,
        selectedStaff,
        // { headers: { "Content-Type": "multipart/form-data" } }
      );

      setStaff(
        staff.map((member) =>
          member._id === selectedStaff._id ? { ...member, ...response.data } : member
        )
      );
      closeModal();
      toast.success("Staff updated successfully!");
    } catch (error) {
      console.error("Error updating staff:", error);
      toast.error("Failed to update staff. Please try again.");
    }
  };

  // Handle form input change
  const handleInputChange = (field, value) => {
    setSelectedStaff((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  // Handle profile photo change
  const handleProfilePhotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedStaff((prevState) => ({
        ...prevState,
        profilePhotoFile: file,
        profilePhoto: URL.createObjectURL(file),
      }));
    }
  };

  // Close modal
  const closeModal = () => {
    setShowModal(false);
    setSelectedStaff(null);
    setIsEditing(false);
  };

  // Handle staff creation (Create New Staff)
  const handleCreateStaff = async () => {
    if (!selectedStaff.name || selectedStaff.name.trim() === "") {
      toast.error("Name is required to create a staff member!");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("name", selectedStaff.name);
      formData.append("Qualification", selectedStaff.Qualification);
      formData.append("department", selectedStaff.department);
      formData.append("Specialization", selectedStaff.Specialization);
      formData.append("Experience", selectedStaff.Experience);

      if (selectedStaff.profilePhotoFile) {
        formData.append("profilePhoto", selectedStaff.profilePhotoFile);
      }

      const response = await api.post(`${process.env.REACT_APP_BASE_URL}/api/v1/staff`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setStaff([...staff, response.data]);
      closeModal();
      toast.success("Staff added successfully!");
    } catch (error) {
      console.error("Error adding staff:", error);
      toast.error("Failed to add staff. Please try again.");
    }
  };

  return (
    <div className="container mx-auto px-4 py-6 space-y-8">
      <ToastContainer position="top-center" autoClose={3000} />

      {/* Banner */}
      <div className="bg-[#00BFA5] text-black text-center font-bold py-4 px-6 max-w-4xl mx-auto text-xl sm:text-2xl md:text-3xl rounded-lg shadow-lg">
        Staff Directory - Explore Profiles & Manage Staff
      </div>

      {/* Table */}
      <div className="overflow-x-auto bg-white shadow-lg rounded-lg border-t-4 border-teal-500">
        <table className="min-w-full table-auto border-collapse relative">
          <thead className="bg-[#00BFA5] text-white">
            <tr>
              <th className="px-2 py-3 text-left text-xs sm:text-sm font-semibold">S No.</th>
              <th className="px-2 py-3 text-left text-xs sm:text-sm font-semibold">Profile</th>
              <th className="px-2 py-3 text-left text-xs sm:text-sm font-semibold">Name</th>
              <th className="hidden sm:table-cell px-2 py-3 text-left text-xs sm:text-sm font-semibold">Qualification</th>
              <th className="hidden md:table-cell px-2 py-3 text-left text-xs sm:text-sm font-semibold">Department</th>
              <th className="hidden lg:table-cell px-2 py-3 text-left text-xs sm:text-sm font-semibold">Specialization</th>
              <th className="hidden xl:table-cell px-2 py-3 text-left text-xs sm:text-sm font-semibold">Experience</th>
              <th className="px-2 py-3 text-center text-xs sm:text-sm font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody>
            {staff?.map((staffMember, index) => (
              <tr key={staffMember._id} className="border-b hover:bg-teal-50 transition duration-200 ease-in-out">
                <td className="px-2 py-3 text-xs sm:text-sm text-gray-700 font-medium">{index + 1}</td>
                <td className="px-2 py-3">
                  <img
                    src={staffMember.profilePhoto && staffMember.profilePhoto[0]
                      ? `/api/uploads/staffimages/${staffMember.profilePhoto[0]}`
                      : '/path/to/default-image.jpg'} // Check for profilePhoto existence
                    alt={staffMember.name}
                    className="w-8 h-8 sm:w-12 sm:h-12 rounded-full shadow-md"
                  />
                </td>
                <td className="px-2 py-3 text-xs sm:text-sm text-gray-700 font-medium">{staffMember.name || "-"}</td>
                <td className="hidden sm:table-cell px-2 py-3 text-xs sm:text-sm">{staffMember.Qualification || "-"}</td>
                <td className="hidden md:table-cell px-2 py-3 text-xs sm:text-sm">{staffMember.department || "-"}</td>
                <td className="hidden lg:table-cell px-2 py-3 text-xs sm:text-sm">{staffMember.Specialization || "-"}</td>
                <td className="hidden xl:table-cell px-2 py-3 text-xs sm:text-sm">{staffMember.Experience || "-"}</td>
                <td className="px-2 py-3 text-center space-x-1 sm:space-x-3">
                  <button
                    onClick={() => handleViewClick(staffMember)}
                    className="text-blue-500 hover:text-blue-700 transition duration-300"
                    title="View Profile"
                  >
                    <FaEye size={16} />
                  </button>
                  <button
                    onClick={() => handleEdit(staffMember)}
                    className="text-teal-500 hover:text-teal-700 transition duration-300"
                    title="Edit Profile"
                  >
                    <FaEdit size={16} />
                  </button>
                  <button
                    onClick={() => handleDelete(staffMember._id)}
                    className="text-red-500 hover:text-red-700 transition duration-300"
                    title="Delete Profile"
                  >
                    <FaTrash size={16} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full sm:w-[400px] space-y-6 p-4 sm:p-6">
            <h2 className="text-xl font-bold text-center text-teal-600">
              {isEditing ? "Edit Staff Details" : `${selectedStaff.name}'s Profile`}
            </h2>
            {isEditing ? (
              <div className="space-y-4">
                <div className="space-y-1">
                  <label className="text-sm font-semibold">Profile Photo</label>
                  <input
                    type="file"
                    onChange={handleProfilePhotoChange}
                    disabled={!isEditing}
                    className="w-full"
                  />
                  {selectedStaff?.profilePhoto && !isEditing && (
                    <img
                      src={`/api/uploads/staffimages/${selectedStaff.profilePhoto}`}
                      alt="Profile"
                      className="mt-2 w-24 h-24 sm:w-32 sm:h-32 rounded-full shadow-md"
                    />
                  )}
                </div>

                <div>
                  <label className="font-semibold">Name:</label>
                  <input
                    type="text"
                    className="border rounded w-full px-2 py-1"
                    value={selectedStaff.name}
                    onChange={(e) => handleInputChange("name", e.target.value)}
                  />
                </div>
                <div>
                  <label className="font-semibold">Qualification:</label>
                  <input
                    type="text"
                    className="border rounded w-full px-2 py-1"
                    value={selectedStaff.Qualification}
                    onChange={(e) => handleInputChange("Qualification", e.target.value)}
                  />
                </div>
                <div>
                  <label className="font-semibold">Department:</label>
                  <input
                    type="text"
                    className="border rounded w-full px-2 py-1"
                    value={selectedStaff.department}
                    onChange={(e) => handleInputChange("department", e.target.value)}
                  />
                </div>
                <div>
                  <label className="font-semibold">Specialization:</label>
                  <input
                    type="text"
                    className="border rounded w-full px-2 py-1"
                    value={selectedStaff.Specialization}
                    onChange={(e) => handleInputChange("Specialization", e.target.value)}
                  />
                </div>
                <div>
                  <label className="font-semibold">Experience:</label>
                  <input
                    type="text"
                    className="border rounded w-full px-2 py-1"
                    value={selectedStaff.Experience}
                    onChange={(e) => handleInputChange("Experience", e.target.value)}
                  />
                </div>


                <div className="flex justify-end space-x-2">
                  <button
                    onClick={closeModal}
                    className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleUpdateStaff}
                    className="px-4 py-2 bg-teal-600 text-white rounded hover:bg-teal-700"
                  >
                    Update
                  </button>
                </div>
              </div>
            ) : (
              <div>
                <p>
                  <span className="font-semibold">Profile:</span>{" "}
                  <img
                    src={selectedStaff.profilePhoto ? `/api/uploads/staffimages/${selectedStaff.profilePhoto}` : "/default-profile.jpg"}
                    alt={selectedStaff.name}
                    className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 rounded-full shadow-md"
                  />
                </p>
                <p>
                  <span className="font-semibold">Name:</span>{" "}
                  {selectedStaff.name || "-"}
                </p>

                <p>
                  <span className="font-semibold">Qualification:</span>{" "}
                  {selectedStaff.Qualification || "-"}
                </p>
                <p>
                  <span className="font-semibold">Department:</span>
                  {selectedStaff.department || "-"}
                </p>
                <p>
                  <span className="font-semibold">Specialization:</span>
                  {selectedStaff.Specialization || "-"}
                </p>
                <p>
                  <span className="font-semibold">Experience:</span>
                  {selectedStaff.Experience || "-"}
                </p>
                {/* Add more fields here */}
                <div className="flex justify-end space-x-2">
                  <button
                    onClick={closeModal}
                    className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
                  >
                    Close
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

    </div>
  );
}








